/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
import lod_ from "lodash";
import { forwardRef, useImperativeHandle, useState } from "react";
import MDBox from "components/Basics/MDBox";

import analyseDocumentDisplay from "./AnalyseDocumentDisplay";
import scrapReview from "./ScrapReview";
import messageList from "./MessageList";
import changeDateCampaign from "./ChangeDateCampaign";
import changeStateCampaign from "./ChangeStateCampaign";
import conversationLight from "./ConversationLight";
import listConversationsLight from "./ListConversationsLight";

import deleteCampaign from "./DeleteCampaign";
import analyseConversationLight from "./AnalyseConversationLight";
import { useSelector } from "react-redux";
import { selectUser } from "redux-react/reducers/userReducers";
import { useResourceActions } from "hooks/useResourceActions";
import { replaceInTextHbr } from "helpers/utilities";
import { downloadSheet } from "helpers/csv";

const SPECIAL_ACTIONS = {
	scrapReview,
	messageList,
	analyseDocumentDisplay,
	changeDateCampaign,
	changeStateCampaign,
	deleteCampaign,
	conversationLight,
	analyseConversationLight,
	listConversationsLight
};

/**
 * ActionsController component
 * This component manages the display of various actions in the application.
 * It uses a ref to allow external components to trigger actions.
 */
const ActionsController = forwardRef((props, ref) => {
	const user = useSelector(selectUser);
	const { updateResource, insertResourceEvent } = useResourceActions();

	const [currentAction, setCurrentAction] = useState({
		open: false,
		action: null
	});

	const isSpecialAction = action => {
		return Object.keys(SPECIAL_ACTIONS).includes(action);
	};

	const isOpen = action => {
		return (
			currentAction.open &&
			(currentAction.action?.config?.action === action || currentAction.action?.code === action)
		);
	};

	const performFrontAction = async (event, values, resource, callback = () => {}) => {
		const method = event?.config?.method;
		switch (method) {
			/** Analyse document -> Assign document to current user */
			case "assignDocument": {
				for (let item of values) {
					let update = {
						agent: user.userID
					};

					if (item.state === "waiting") {
						update.state = "ongoing";
					}

					// Update resource
					updateResource(resource?.code, item._id, update, () => {
						callback({
							success: true,
							result: update
						});
					});
				}
				break;
			}
			/** Analyse document -> unassign document from current document's user */
			case "unassignDocument": {
				for (let item of values) {
					let update = {
						agent: null
					};

					// Update resource
					updateResource(resource?.code, item._id, update, () => {
						callback({
							success: true,
							result: update
						});
					});
				}
				break;
			}
			/** Generate CSV file */
			case "generateCSVFile": {
				const config = event?.config || {};

				if (lod_.isNil(config?.inputs) || lod_.isNil(config?.mappingIn)) {
					callback({
						success: false,
						result: {}
					});
					return;
				}

				values.forEach(async item => {
					try {
						const csvDatas = [];
						const inputs = replaceInTextHbr(config.inputs, item, true);
						let payload = inputs.payload;

						if (!Array.isArray(payload) && lod_.isObject(payload)) {
							payload = [payload];
						}

						const filename = replaceInTextHbr(config.fileName || "export.csv", item);

						for (let data of payload) {
							const mappedData = replaceInTextHbr(config.mappingIn, data, true);
							csvDatas.push(mappedData);
						}

						await downloadSheet(
							csvDatas,
							{
								skipHeader: true
							},
							filename,
							"xlsx"
						);

						insertResourceEvent(resource?.code, item._id, {
							action: "generateCSVFile",
							actor: user.userID,
							payload: {}
						});

						callback({
							success: true,
							result: {}
						});
					} catch (error) {
						callback({
							success: false,
							result: {}
						});
					}
				});

				break;
			}
			default: {
				break;
			}
		}
	};

	// Expose methods to the parent component via ref
	useImperativeHandle(ref, () => ({
		isSpecialAction,
		performFrontAction,
		startAction: (action, values) => {
			setCurrentAction({
				open: true,
				action,
				values
			});
		}
	}));

	return (
		<MDBox>
			{Object.entries(SPECIAL_ACTIONS).map(([actionKey, ActionComponent]) => (
				<ActionComponent
					key={actionKey}
					{...currentAction}
					open={isOpen(actionKey)}
					perform={props.performActionHandle}
					insertResource={props.insertResource}
					updateResource={props.updateResource}
					deleteResource={props.deleteResource}
					insertResourceEvent={props.insertResourceEvent}
					resource={props.resource}
					dictionary={props.dictionary}
					performFrontAction={performFrontAction}
					onClose={() => setCurrentAction({ open: false })}
				/>
			))}
		</MDBox>
	);
});

export default ActionsController;
